import { render, staticRenderFns } from "./VerFacturaModal.vue?vue&type=template&id=2a238198"
import script from "./VerFacturaModal.vue?vue&type=script&lang=js"
export * from "./VerFacturaModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports